















import {
  Component,
  Vue,
  Prop,
} from "vue-property-decorator";

import bpui from 'bpui.js';

@Component({
  components: {
    bpDialog: bpui.bpDialog,
  }
})
export default class extends Vue {
  @Prop({default: 'title2'}) title:string;
}
